<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm ts-capitalize">{{ model.compensate_item }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-loading-banner :loading="loadingPreData">
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="ts-flex">
            <div class="ts-flex">
              <label class="col-sm-4 control-label"> {{ $t('payMonthlyCompensate.year') }}</label>
              <div>
                <ts-date-picker-input
                  :class="{ 'is-invalid': errors.has('cycle_year') }"
                  format="YYYY"
                  v-model="model.cycle_year"
                ></ts-date-picker-input>
              </div>
              <div class="invalid-feedback" v-if="errors.has('cycle_year')">
                {{ errors.first('cycle_year') }}
              </div>
            </div>
            <div class="ts-flex">
              <label class="col-sm-4 control-label"> {{ $t('payMonthlyCompensate.month') }}</label>
              <div>
                <ts-date-picker-input
                  :class="{ 'is-invalid': errors.has('cycle_month') }"
                  format="MM"
                  v-model="model.cycle_month"
                ></ts-date-picker-input>
              </div>
              <div class="invalid-feedback" v-if="errors.has('cycle_month')">
                {{ errors.first('cycle_month') }}
              </div>
            </div>
            <div class="ts-flex-grow"></div>
            <ts-button
              class="btn-primary mr-2"
              @click.prevent="generate"
              :waiting="saving"
              :disabled="model.selectedEmployees.length <= 0"
            >
              {{ $t('button.generate') }}
            </ts-button>
          </div>
        </form>
      </ts-card-wrapper>
      <div class="menu-container">
        <div class="leave-record-table-container">
          <ts-card-wrapper>
            <div class="d-flex justify-content-end">
              <ts-input v-model="searchText" :placeholder="$t('search')" />
            </div>
          </ts-card-wrapper>
          <table class="table table-hover ui-table ts-table" v-if="availableEployeeCompensates.length > 0">
            <thead>
              <tr>
                <th class="with-checkbox ui-checkable">
                  <ts-checkbox v-model="checkAll" @change="selectAll">
                    All
                  </ts-checkbox>
                </th>
                <th class="ts-whitespace-no-wrap text-center">{{ $t('payMonthlyCompensate.cardId') }}</th>
                <th class="ts-whitespace-no-wrap">{{ $t('payMonthlyCompensate.employeeName') }}</th>
                <th class="ts-whitespace-no-wrap text-center">{{ $t('payMonthlyCompensate.hireDate') }}</th>
                <th v-if="model.keyword == 'ANL'" class="ts-whitespace-no-wrap text-center">
                  {{ $t('payMonthlyCompensate.anlDayRemain') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in availableEployeeCompensates" :key="index">
                <td class="with-checkbox ui-checkable">
                  <ts-checkbox :value="record.employee_id" v-model="model.selectedEmployees"> </ts-checkbox>
                </td>
                <td class="ts-whitespace-no-wrap text-center">{{ record.card_id }}</td>
                <td class="ts-whitespace-no-wrap">{{ record.employee_name }}</td>
                <td class="ts-whitespace-no-wrap text-center">{{ record.hire_date }}</td>
                <td v-if="model.keyword == 'ANL'" class="ts-whitespace-no-wrap text-center">
                  {{ record.anl_day_remain }}
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="availableEployeeCompensates.length <= 0" class="text-center mt-5">
            {{ $t('payMonthlyCompensate.noFoundRecord') }}
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'import-custom-compensate-form',
  props: ['data'],
  data() {
    return {
      model: {
        compensate_id: 0,
        compensate_item: 0,
        keyword: '',
        cycle_year: moment().format('YYYY'),
        cycle_month: moment().format('MM'),
        selectedEmployees: []
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false,
      searchText: ''
    }
  },
  computed: {
    ...mapState('hr/payMonthlyCompensate', ['employeeCompensateLists']),

    availableEployeeCompensates() {
      return this.employeeCompensateLists.filter(em => {
        if (this.searchText.trim() !== '') {
          return (
            em.card_id.toLowerCase().includes(this.searchText.toLowerCase().trim()) ||
            em.employee_name.includes(this.searchText.toLowerCase().trim())
          )
        }

        return this.employeeCompensateLists
      })
    },
    checkAll() {
      return this.model.selectedEmployees.length == this.employeeCompensateLists.length
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.model.compensate_id = this.data.compensate_id
      this.model.compensate_item = this.data.compensate_item
      this.model.keyword = this.data.custom_keyword
      this.$store.commit('hr/payMonthlyCompensate/RECEIVE_EMPLOYEE_COMPENSATE_LISTS', [])
      this.loadingPreData = true
      this.$store
        .dispatch('hr/payMonthlyCompensate/fetchEmployeeCompensateList', this.model)
        .then(() => {
          this.loadingPreData = false
          this.autoSelectAll()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    selectAll(e) {
      if (e) {
        this.model.selectedEmployees = []
        this.$nextTick(() => {
          this.employeeCompensateLists.map(el => {
            this.model.selectedEmployees.push(el.employee_id)
          })
        })
      } else {
        this.model.selectedEmployees = []
      }
    },
    autoSelectAll() {
      this.model.selectedEmployees = []
      this.$nextTick(() => {
        this.employeeCompensateLists.map(el => {
          this.model.selectedEmployees.push(el.employee_id)
        })
      })
    },
    async generate() {
      this.errors = new Errors()
      this.saving = true

      try {
        let response = await this.$store.dispatch('hr/payMonthlyCompensate/generate', this.model)

        return this.$store.dispatch('hr/payMonthlyCompensate/fetch').then(res => {
          this.saving = false
          this.$emit('close')
          this.$emit('before-close')
          this.$toasted.success(response.message)
          return Promise.resolve(res)
        })
      } catch (error) {
        this.$toasted.error(error.message)
        this.errors = new Errors(error.errors)
      }

      this.saving = false
    }
  },
  watch: {
    'model.cycle_year': function() {
      this.fetchData()
    },
    'model.cycle_month': function() {
      this.fetchData()
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-container {
  height: 50vh;
  overflow-y: scroll;
  overflow-x: scroll;
}
.leave-record-table-container {
  height: 48vh;

  .table > thead > tr > th {
    position: sticky;
    top: 0;
    background: rgba(230, 230, 230, 1);
    z-index: 10;
  }
  table th,
  td {
    padding: 10px 15px;
    vertical-align: middle !important;
    white-space: nowrap;
  }
}
::-webkit-scrollbar {
  height: 10px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #dee0e0;
}
div::-webkit-scrollbar-thumb:hover {
  background: #bebfc0;
}
</style>
